module.exports = __webpack_public_path__ + "img/35.d5af0a5c.png";